module.exports = __webpack_public_path__ + "static/media/line.6617757f.PNG";